<template>
    <div class="intro">
        <h1>Introductie</h1>
        <p>Welkom bij de keuzehulp van IJsclub Haarlem. Door je een paar vragen te stellen krijgen wij een beter beeld van wat wij jou kunnen bieden. Laat je door ons zo goed mogelijk helpen, je zit nog nergens aan vast.</p>
        <button class="app-btn" @click="$emit('setPhase', 1)">
            Ga verder
        </button>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/main.scss';

</style>